import sendEventTracking from '@utils/stats/sendEventTracking'

export default function sendEventTrackingButton({
  isAcceptPerformance,
  isAcceptTargeting,
  isAcceptAdvertising,
}) {
  sendEventTracking({
    eventCategory: 'gdprnoti',
    eventAction: 'modal',
    eventLabel: isAcceptPerformance
      ? 'gdprnoti-setting-2-on'
      : 'gdprnoti-setting-2-off',
  })

  sendEventTracking({
    eventCategory: 'gdprnoti',
    eventAction: 'modal',
    eventLabel: isAcceptTargeting
      ? 'gdprnoti-setting-3-on'
      : 'gdprnoti-setting-3-off',
  })

  sendEventTracking({
    eventCategory: 'gdprnoti',
    eventAction: 'modal',
    eventLabel: isAcceptAdvertising
      ? 'gdprnoti-setting-4-on'
      : 'gdprnoti-setting-4-off',
  })
}
